import { Component } from 'vue';
import { ContactTargetCategory } from '@/customer/models/Customer';
import Modal from '@/general/utils/Modal';
import DossierContactTarget from '@/shared/models/DossierContactTarget';
import ContactContext from '../models/ContactContext';
import DossierContact from '../models/DossierContact';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const DossierContactModal = (): Component => import('../modals/DossierContactModal.vue');
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const DossierContactTargetSelectorModal = (): Component => import('../modals/DossierContactTargetSelectorModal.vue');

export default class ContactModals {
  static contact(context: ContactContext, contact?: DossierContact): Promise<void> {
    return Modal.open(DossierContactModal, { context, contact });
  }

  static selectTargets(context: ContactContext, title?: string, selectedTargets?: Array<DossierContactTarget>, categories?: Array<ContactTargetCategory>, required?: boolean): Promise<Array<DossierContactTarget>> {
    return Modal.openAndWait(DossierContactTargetSelectorModal, { context, title, selectedTargets, categories, required });
  }
}